export const environment = {
  production: true,
  api_url: 'https://api.umfprep.ro/',
  api_key: '2506409f-5120-442b-b571-hdjfi92rhfeoioq-5120-442b-b571-2d2ca28f1597',
  fb_pixel_id: '1399504997554633',
};
